import { CastForEducation, Home, Lock, ManageAccounts, MiscellaneousServices, Newspaper, Password, People, Restore, Storage, Store } from "@mui/icons-material";
import Logout from "@mui/icons-material/Logout";
import { Divider, List } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ApiError } from "../../Api/ApiError";
import { logout } from "../../Api/Staff";
import { SystemObjectStore } from "../../ObjectStore/SystemObjectStore";
import { UserObjectStore } from "../../ObjectStore/UserObjectStore";
import NaviItem from "../atoms/NaviItem";
import { ChangePasswordDialog } from "../organisms/ChangePasswordDialog";


const AuthNavi: React.FC = () => {
    const { enqueueSnackbar } = useSnackbar()
    const navigate = useNavigate()
    const { userObjectState, userObjectDispatch } = React.useContext(UserObjectStore)
    const { systemObject } = React.useContext(SystemObjectStore)
    const [changePassword, setChangePassword] = React.useState<boolean>(false)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const onLogout = React.useCallback(() => {
        logout({signal: abortController.signal}).then(() => {
            userObjectDispatch({ type: "unsetUser" })
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
    }, [abortController, enqueueSnackbar, userObjectDispatch])

    const showOldVersion = React.useCallback(() => {
        if( systemObject.systemBaseUrl ) {
            window.location.href = `${systemObject.systemBaseUrl}sms_manager/`
        }
    }, [systemObject.systemBaseUrl])

    const onChangePassword = () => {
        setChangePassword(true)
    }
    return (
        <List component="nav">
            <NaviItem
                text="ダッシュボード"
                onClick={() => {
                    navigate("/")
                }}
                icon={<Home />}
            />
            {(userObjectState.stfAccessList.includes("CustomerAdmin") && systemObject.databaseVersion && systemObject.databaseVersion >= 11 && systemObject.enableOnlineLesson) &&
                <NaviItem
                    text="オンラインレッスン"
                    onClick={() => {
                        navigate("/online_lesson")
                    }}
                    icon={<CastForEducation />}
                />
            }
            <NaviItem
                text="店舗管理"
                onClick={() => {
                    navigate("/store")
                }}
                icon={<Store />}
            />
            <Divider sx={{ my: 1 }} />
            {userObjectState.stfAccessList.includes("SystemConfig") &&
                <NaviItem
                    text="システム設定"
                    onClick={() => {
                        navigate("/setting")
                    }}
                    icon={<MiscellaneousServices />}
                />
            }
            {(userObjectState.stfAccessList.includes("SystemConfig") || userObjectState.stfAccessList.includes("SYSTEM_LOGIN")) &&
                <NaviItem
                    text="データベース管理"
                    onClick={() => {
                        navigate("/database")
                    }}
                    icon={<Storage />}
                />
            }
            {(userObjectState.stfAccessList.includes("AuthConfig") || userObjectState.stfAccessList.includes("SYSTEM_LOGIN")) &&
                <NaviItem
                    text="アクセス権限管理"
                    onClick={() => {
                        navigate("/auth")
                    }}
                    icon={<Lock />}
                />
            }
            {(userObjectState.stfAccessList.includes("NewsAdmin") || userObjectState.stfAccessList.includes("SYSTEM_LOGIN")) &&
                <NaviItem
                    text="ニュース管理"
                    onClick={() => {
                        navigate("/news")
                    }}
                    icon={<Newspaper />}
                />
            }
            {(userObjectState.stfAccessList.includes("StaffAdmin") || userObjectState.stfAccessList.includes("SYSTEM_LOGIN")) &&
                <NaviItem
                    text="スタッフ管理"
                    onClick={() => {
                        navigate("/staff")
                    }}
                    icon={<ManageAccounts />}
                />
            }
            {(userObjectState.stfAccessList.includes("CustomerAdmin") || userObjectState.stfAccessList.includes("SYSTEM_LOGIN")) &&
                <NaviItem
                    text="顧客管理"
                    onClick={() => {
                        navigate("/customer")
                    }}
                    icon={<People />}
                />
            }
            <Divider sx={{ my: 1 }} />
            <NaviItem
                icon={<Logout />}
                onClick={onLogout}
                text="サインアウト"
            />
            <NaviItem
                icon={<Restore />}
                text="旧バージョン"
                onClick={showOldVersion}
            />
            <Divider sx={{ my: 1 }} />
            <NaviItem
                icon={<Password />}
                onClick={onChangePassword}
                text="パスワードを変更"
            />
            <ChangePasswordDialog
                open={changePassword}
                onClose={() => {
                    setChangePassword(false)
                }}
            />
        </List>
    );
}

export default AuthNavi